import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { I18nProvider } from "./i18n";
import "./styles.css";
import "./checkin-kiosk.css";
import "./instructor.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode><I18nProvider><App /></I18nProvider></StrictMode>,
);
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js"));
}
